// extracted by mini-css-extract-plugin
export default {"skip-links":"SkipLinks_skip-links__s297W","skip-links__link":"SkipLinks_skip-links__link__3izFH"};